const OPEN_DELAY = 600;
export {
  OPEN_DELAY
};
//# sourceMappingURL=constants.js.map
